<template>
  <div>
    <b-col md="3" >
      <b-carousel
          indicators
          :img-width="customData.width"
          :img-height="customData.height"
          :controls="controls"
          :interval="customData.interval"
          v-if="store.getters.isRunModePlatform"
      >
        <!-- Text slides with image -->
          <b-carousel-slide v-for="img in value"
            :key="img.localURL"
            :imgSrc="img.localURL"  
            class="min-height-100"
          />
          
      </b-carousel>

      <b-carousel
          indicators
          :img-width="customData.width"
          :img-height="customData.height"
          :controls="controls"
          :interval="customData.interval"
          v-else
      >

          <b-carousel-slide v-for="img in previews"
            :key="img.publicURL"
            :imgSrc="img.publicURL"
            class="min-height-100"
          />
          
      </b-carousel>
    </b-col>

    <b-input-group>
        <b-dropdown text="Source" class="m-2">
            <b-dropdown-item @click="chooseFromLibrary()" v-if="showChooseFromLibrary">Choose from library</b-dropdown-item>
            <b-dropdown-item @click="chooseFromDevice()" v-if="showChooseFromDevice">Choose from device</b-dropdown-item>
            <b-dropdown-item @click="chooseExternalSource()" v-if="customData.chooseExternalSource">External source</b-dropdown-item>
        </b-dropdown>

        <b-button variant="danger" class="m-2" @click="clear" v-if="this.content.length > 0"> Clear </b-button>

        <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
      </b-input-group>


      <b-modal v-model="chooseModal.show" size="lg" hide-footer>
          <slot name="IdentityFieldImageCarousel" v-if="this.chooseModal.type == 'choose_from_library'" :itemSelected="itemSelected" mode="popup"></slot>
          <b-form-textarea placeholder="Absolute path to images devided by comma (,)" v-model="externalSource" v-if="this.chooseModal.type == 'external_source'" />
          <div v-if="this.chooseModal.type == 'choose_from_device'">
            <b-form-file multiple v-model="uploadFiles" accept="image/*" @change="previewImages"/>
            <b-button @click="upload" v-if="uploadFiles.length > 0" class="m-2"> Upload </b-button>
          </div>
      </b-modal>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
      field: {
          type: Object
      },
      value: {
          type: Array,
          default: function() {
              return []
          }
      },
      store: {
        type: Object
      },

      translator: {
        type: Function
      }
  },
  watch: {
      content(val) {
          this.check(val)
      }
  },
  data: function() {
    return {
      chooseModal: {
        show: false,
        type: ''
      },
      errors: [],
      uploadFiles: [],
      previews: []
    }
  },
  methods: {
    itemSelected(data) {
      this.content = data

      console.log("itemSelected", data)
    },

    clear() {
      this.$bvModal.msgBoxConfirm(this.translator('clearAllImages')).then(resp => {
        if (resp) {
          this.content = []
        }
      })
    },

    formatLocalURL(img) {
      return this.$mediaHttp.defaults.baseURL + img
    },

     check(val) {
          this.errors = []
          val = val || []

          if (this.field.constraints.required) {     
            if (val.length < 1) {
                  this.errors.push(this.translator("identityField.requiredField"))
            }

            if (val.length > this.customData.max_images) {
                this.errors.push(this.translator("identityField.maxNrOfImages", {max: this.customData.max_images}))
            }
            
          }

          this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
    },

    chooseFromLibrary() {
      this.chooseModal.show = true
      this.chooseModal.type = "choose_from_library"
    },

    chooseExternalSource() {
      this.chooseModal.show = true
      this.chooseModal.type = "external_source"
    },

    chooseFromDevice() {
      this.chooseModal.show = true
      this.chooseModal.type = "choose_from_device"
    },

    upload() {
      if (this.uploadFiles.length > this.customData.max_images) {
        this.$bvModal.msgBoxOk(this.translator("identityField.maxNrOfImagesExceeded"))
        return
      }

      this.store.dispatch("uploadMedia", {uploadDir: "",  uuid: this.customData.defaultLibrary, files: this.uploadFiles, field: this.field.key}).then(resp => {
        this.content = resp.data.map(d => {
          return "/media/library/" + d.library_uuid + "/get/" + d.key
        })

        this.chooseModal.show = false
      }).catch(err => {
        this.$bvModal.msgBoxOk(this.translator("identityField.failedToUploadMediaFiles"))
      })
    },

    previewImages(e) {
      this.previews = [];

      for (var i = 0; i < e.target.files.length; i++) {
        this.previews.push(URL.createObjectURL(e.target.files[i]));
      }
    }
  },
  computed: {
      content: {
          get() {
              return this.value || [];
          },

          set(val) {
            this.check(val)

            val = val.map(v => {
              let publicUrl = v.public_url
              if (publicUrl == "") {
                publicUrl = v.local_url
              }

              return {
                localURL: v.local_url,
                publicURL: publicUrl
              }
            })

             this.$emit("input", val)
          }
      },

      constraints() {
        return this.field.constraints
      },

      customData() {
          return this.field.constraints.custom_data.carousel || {
            width: 1024,
            height: 480,
            controls: false,
            interval: 0,
            chooseFromLibrary: false,
            chooseFromDevice: false,
            chooseExternalSource: true,
            libraries: [],
            defaultLibrary: null,
            max_images: 5
          }
      },
      
      controls() {
        if (this.content.length < 1) return false

        return this.customData.controls
      },

      externalSource: {
        get() {
          let cont = this.content.map(c => {
            return c.localURL
          })

          return cont.join(",")
        },

        set(val) {
          let cont = val.split(",")
          cont = cont.map(c => {
            return {
              localURL: c,
              publicURL: c
            }
          })

          this.check(cont)

          this.$emit('input', cont)
        }
      },

      showChooseFromLibrary() {
        return this.store.getters.isRunModePlatform && (this.customData.chooseFromLibrary && this.store.getters.isIntegrationActive('protokol-media'))
      },

      showChooseFromDevice() {
        return this.customData.chooseFromDevice && this.store.getters.isIntegrationActive('protokol-media')
      }
  },

  mounted() {
    this.check(this.value)
  }
}
</script>